import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'

import { digObject } from '@domain-group/javascript-utils'
import {
  Box, DashboardModule, Image, Link, Text,
} from '@domain-group/suit-theme'

import type { OrderModel, ProviderModel } from '@models/types'

type ProviderProps = {
  order: OrderModel,
  provider: ProviderModel,
}

const Provider = (props: ProviderProps) => {
  const { order: { id }, provider } = props

  const logoUrl = digObject(provider, 'alternate_logo.thumb')

  return (
    // @ts-expect-error TS2322
    <DashboardModule direction="column" title="Provider">
      <Box flexDirection="column" flexShrink={0} padding="large">
        <Box alignItems="center">
          <Image
            backgroundSize="contain"
            borderRadius={5}
            boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
            height={38}
            url={logoUrl}
            width={60}
          />
          <Box flexDirection="column" fontSize="xsmall" marginLeft="large">
            <Text color="lightGrey">Order #{id}</Text>
            <Text color="bodyFontLightColor" marginTop="small">
              from {provider.title}
            </Text>
          </Box>
        </Box>

        {!provider.active && (
          <Box flexDirection="column" lineHeight="1.3" marginTop="large" padding="large" variant="whiteGrey">
            <Text color="orange" fontSize="small">
              <FontAwesomeIcon icon={faExclamationTriangle} /> Unable to Approve Order.
            </Text>

            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="large">
              Realhub is unable to send orders to this provider currently due to a technical issue.
            </Text>

            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
              The provider has been notified of the issue.
            </Text>

            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
              For an estimated time until resolution please <strong>contact the provider directly.</strong>
            </Text>

            <Link
              href={`mailto:${provider.email}?subject=Unable to Approve Order #${id} on Realhub`}
              textProps={{ fontSize: 'xsmall', marginTop: 'medium' }}
            >
              {provider.email}
            </Link>
          </Box>
        )}
      </Box>
    </DashboardModule>
  )
}

export default Provider
